import { memo } from "react";
import React, { FC } from "react";

type Props = {
  code: string;
  name: string;
  isOpen: boolean;
};

const SelectorButtonComponent: FC<Props> = ({ code, name, isOpen }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <span
        style={{
          fontSize: "18px",
          lineHeight: "145%",
          fontWeight: 900,
          letterSpacing: "-0.36px",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          overflow: "hidden",
          color: isOpen ? "#000000" : "#ffffff",
        }}
      >
        {code ?? ""}
      </span>
      <span
        style={{
          marginTop: "-3px",
          fontSize: "12px",
          lineHeight: "145%",
          fontWeight: 500,
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          overflow: "hidden",
          letterSpacing: "-0.36px",
          color: isOpen ? "#000000" : "#ffffff",
        }}
      >
        {name ?? ""}
      </span>
    </div>
  );
};

export const SelectorButton = memo(SelectorButtonComponent);
